var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 68,
    viewBox: "0 0 38 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#959595",
    width: 72,
    height: 68,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.229 25.917H16.44a.792.792 0 01-.771-.81v-3.176a.8.8 0 00.771.743h7.706a.812.812 0 000-1.621H16.44a.791.791 0 00-.771.743v-3.107a.8.8 0 00.771.743h7.706a.812.812 0 000-1.621H16.44a.791.791 0 00-.771.743v-3.109a.8.8 0 00.771.744h7.706a.812.812 0 000-1.622H16.44a.791.791 0 00-.771.744v-3.108a.8.8 0 00.771.743h7.706a.812.812 0 000-1.621H16.44a.791.791 0 00-.771.743V8.894a.792.792 0 01.771-.811h10.789a.793.793 0 01.772.811v16.213a.793.793 0 01-.772.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e8ee",
    d: "M20.66 5.187a.5.5 0 00-.5-.171l-9.67 2.4a.774.774 0 00-.49.789v17.6a.773.773 0 00.493.786l9.67 2.4a.442.442 0 00.111.014.521.521 0 00.386-.184.919.919 0 00.219-.616v-22.4a.915.915 0 00-.219-.618z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyDocument);
export default __webpack_public_path__ + "static/media/reply-document.a4ff1c156159941463a87577629b505a.svg";
export { ForwardRef as ReactComponent };